import parameterApplications from 'common/parameterApplications';
import { v4 as uuid } from 'uuid';
import {
    bool as validateBool, string as validateString, trackingId as validateTrackingId, oneOfValue as validateOneOfValue,
    naturalInteger as validateNaturalInteger, languageCode as validateLanguageCode, entityType as validateEntityType,
    limit as validateLimit, countryCode as validateCountryCode
} from '../validators';
import {commaSeparated as convertCommaSeparated, array as convertArray} from '../converters';

export default () => {
    return {
        key: {
            validators: [validateString]
        },
        trackingId: {
            validators: [validateTrackingId],
            application: parameterApplications.HEADER,
            defaultValue: uuid
        },
        countryCode: {
            validators: [validateCountryCode],
            required: true
        },
        limit: {
            validators: [validateLimit]
        },
        view: {
            validators: [validateOneOfValue(
                ['AR', 'IL', 'MA', 'IN', 'PK', 'Unified', 'RU', 'TR', 'CN'],
                'view')]
        },
        offset: {
            validator: [validateNaturalInteger],
            name: 'ofs'
        },
        language: {
            validators: [validateLanguageCode]
        },

        /**
         * Represents the street's number for the structured address.
         *
         * @attribute streetNumber
         * @param {String} [options.streetNumber] The street's number.
         */
        streetNumber: {
            validators: [validateString]
        },

        /**
         * Represents the street's name for the structured address.
         *
         * @attribute streetName
         * @param {String} [options.streetName] The street's name.
         */
        streetName: {
            validators: [validateString]
        },

        /**
         * Represents the cross street's name for the structured address.
         *
         * @attribute crossStreet
         * @param {String} [options.crossStreet] The cross street's name.
         */
        crossStreet: {
            validators: [validateString]
        },

        /**
         * Represents the municipality (city/town) for the structured address.
         *
         * @attribute municipality
         * @param {String} [options.municipality] The municipality's name (city/town).
         */
        municipality: {
            validators: [validateString]
        },

        /**
         * Represents the municipality subdivision (sub/super city) for the structured address.
         *
         * @attribute municipalitySubdivision
         * @param {String} [options.municipalitySubdivision] The municipality subdivision (sub/super city).
         */
        municipalitySubdivision: {
            validators: [validateString]
        },

        /**
         * Represents the area's name for the structured address.
         *
         * @attribute countryTertiarySubdivision
         * @param {String} [options.countryTertiarySubdivision] The name of the area.
         */
        countryTertiarySubdivision: {
            validators: [validateString]
        },

        /**
         * Represents the county's name for the structured address.
         *
         * @attribute countrySecondarySubdivision
         * @param {String} [options.countrySecondarySubdivision] The county's name.
         */
        countrySecondarySubdivision: {
            validators: [validateString]
        },

        /**
         * Represents the state or province's name for the structured address.
         *
         * @attribute countrySubdivision
         * @param {String} [options.countrySubdivision] The state or province.
         */
        countrySubdivision: {
            validators: [validateString]
        },

        /**
         * Represents the zip code or postal code for the structured address.
         *
         * @attribute postalCode
         * @param {String} [options.postalCode] The zip or postal code.
         */
        postalCode: {
            validators: [validateString]
        },

        protocol: {
            validators: [validateOneOfValue(['http', 'https'], 'protocol')]
        },
        bestResult: {
            validators: [validateBool]
        },
        timeZone: {
            validators: [validateOneOfValue(['iana'], 'timeZone parameter')]
        },
        extendedPostalCodesFor: {
            validators: [validateString]
        },
        entityTypeSet: {
            converters: [convertArray, convertCommaSeparated],
            validators: [validateEntityType]
        }
    };
};
